<template>
	<FullModal ref="accessModal">
		<template #head>
			<NavbarSearch :opened="true" @changed="searching" @closed="$refs.accessModal.close()" />
		</template>

		<Loader :show="loading" type="inline" />

		<div class="list">
			<div class="item" v-for="(item, i) in searchResults" :key="i">
				<div class="circle" :style="{ 'background-color': item.client.profileColor }">
					<i class="icon icon-man-people-streamline-user"></i>
					<div class="vip-badge" v-if="item.membership">VIP</div>
				</div>
				<div>
					<h3>{{ item.client.name }} {{ item.client.lastname }}</h3>
					<p>{{ item.client.document }}</p>
				</div>
			</div>
		</div>

		<div class="alert alert-dark text-center" v-if="!loading && access.length == 0">
			El evento aun no tiene asistentes registrados
		</div>
	</FullModal>
</template>

<script>
import gql from "graphql-tag"
import FullModal from "@/components/FullModal"
import NavbarSearch from "@/components/NavbarSearch"

export default {
	name: "EventAccess",
	components: {
		FullModal,
		NavbarSearch
	},
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			loading: false,
			access: [],

			searchResults: []
		}
	},

	methods: {
		open() {
			this.searchResults = []
			this.load()
			this.$refs.accessModal.open()
		},
		searching(term) {
			if (term) {
				this.searchResults = this.access.filter((item) => {
					return term
						.toLowerCase()
						.split(" ")
						.every((v) => {
							return (
								item.client.name.toLowerCase().includes(v) ||
								item.client.lastname.toLowerCase().includes(v) ||
								item.client.document.toLowerCase().includes(v)
							)
						})
				})
			} else {
				this.searchResults = this.access
			}
		},

		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							eventAccessCheckIn(eventId: $id) {
								data {
									id
									createdAt
									event {
										id
										name
									}
									ticket {
										id
										ticketType {
											id
											name
										}
									}
									client {
										id
										name
										lastname
										document
										profileColor
										email
									}
									membership {
										id
										membershipType {
											id
											name
										}
									}
								}
							}
						}
					`,
					variables: {
						id: this.eventId
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.access = data.eventAccessCheckIn.data
					this.searchResults = this.access
					this.loading = false
				})
				.catch((err) => {
					// this.$toast.error("Error al cargar la inspección")
				})
		}
	}
}
</script>

<style scoped lang="scss">
.list {
	.item {
		padding: 8px 12px;
		display: flex;
		align-items: center;

		&:hover {
			background-color: #2e2e2e;
		}

		.circle {
			width: 42px;
			height: 42px;
			border-radius: 24px;
			margin-right: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			.icon {
				width: 22px;
				height: 22px;
				font-size: 20px;
			}

			.vip-badge {
				display: block;
				display: block;
				font-size: 0.6rem;

				font-weight: 500;
				position: absolute;
				width: 34px;
				height: 17px;
				bottom: -10px;

				border-radius: 14px;
				background-color: #000;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		h3 {
			font-size: 1rem;
			color: #fff;
			font-weight: 500;
		}
		p {
			font-size: 0.8rem;
			color: #fff;
			line-height: 0.8rem;
			margin: 0px;
		}
	}
}
</style>
